import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Grid } from "@material-ui/core";
import { ModalTemplate } from "../../../../../../components/modals/modal-template/modal-template.component";
import {
  BorderedContainer,
  ListContainer,
  SearchContainer,
} from "../../../../../../components/modals/modal-template/modal-template.styles";
import { SearchField } from "../../../../../../components/form-controls/search-field/search-field.component";
import { SearchProductsTable } from "../search-products-table/search-products-table.component";
import { GreenButton } from "../../../../../../components/form-controls/button/green-button/green-button.component";
import { IProductDetail } from "../../../../../../types/product/iproduct-detail.interface";
import { IProductRow } from "../../types/iproduct-row/iproduct-row.interface";
import * as store from "../../../../store/products.store";
import { AddProductModalProps } from "./add-product-modal.props";
import React from "react";
import { IBriefProduct } from "../../../../../../types/product/ibrief-product/ibrief-product.interface";
import { mapSearchResultsToProductRow } from "../../types/iproduct-row/iproduct-row.functions";

export const AddProductModal = (props: AddProductModalProps) => {
  const searchResults = useSelector(store.getSearchResults);

  const [products, setProducts] = useState<IProductRow[]>([]);

  useEffect(() => {
    setProducts(mapSearchResultsToProductRow(searchResults, props.products));
    return () => setProducts([]);
  }, [searchResults, props.products]);

  const handleSearchByTerm = useCallback((searchTerm: string) => {
    store.search(searchTerm);
  }, []);

  const handleCloseModal = () => {
    props.onClose();
    setProducts([]);
  };

  const isProductSelected = (product: IProductDetail) =>
    props.products.some((aProduct: IBriefProduct) => aProduct.productDetail.id === product.id);

  const handleClickProduct = (product: IProductDetail) => {
    if (isProductSelected(product)) {
      return null;
    }
    props.onAddProduct(product);
  };

  const hasProducts = () => products && products.length > 0;

  return (
    <ModalTemplate
      header="Add Product"
      closeModal={handleCloseModal}
      open={props.isOpen}
      size="large"
    >
      <Grid item xs={12}>
        <BorderedContainer>
          <SearchContainer>
            <SearchField
              id="product-search"
              label="Search"
              onSearch={handleSearchByTerm}
              placeholder="Search Item Code or Desc."
              debounceTime={350}
              searchOnMount={false}
            />
          </SearchContainer>

          <ListContainer>
            <SearchProductsTable
              showIf={hasProducts()}
              products={products}
              handleClickProduct={handleClickProduct}
            />
            {(!products || !products.length) && "No results found."}
          </ListContainer>
        </BorderedContainer>
      </Grid>

      <Grid item xs={12} className="text-right">
        <div className="form-group buttons">
          <GreenButton onClick={handleCloseModal}>Done</GreenButton>
        </div>
      </Grid>
    </ModalTemplate>
  );
};
